import { jsx } from "@ecopages/jsx/jsx-runtime";
import { cx } from "@/lib/cx";
export function RuiChip({
  children,
  variant = "default",
  class: className,
  ...props
}) {
  return /* @__PURE__ */jsx("span", {
    ...props,
    class: cx("rui-chip", `rui-chip--${variant}`, className),
    children
  });
}